import PaisList from './PaisList'

export default {
  list: PaisList,
}
